import { ErrorHandler, inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { captureException } from '@sentry/angular';
import { DataAccessAuditActionsService } from '@ic-monorepo/data-access-firestore';
import { SubmissionFlowStore } from '@ic-monorepo/shared-submissions';
import { AuditActionUiTypes } from '@ic-monorepo/shared-types';
import { take } from 'rxjs';

@Injectable()
export class PatientSubmissionErrorHandler implements ErrorHandler {
  private auditActionsService = inject(DataAccessAuditActionsService);
  private router = inject(Router);
  private injector = inject(Injector);

  handleError(error: any): void {
    try {
      const requestId = this.router.routerState?.snapshot?.root?.queryParamMap?.get('requestId');

      let patientId = 'unavailable';
      try {
        const sfStore = this.injector.get(SubmissionFlowStore, null);
        sfStore?.full$.pipe(take(1)).subscribe(state => {
          patientId = state?.entryFlowDetails?.patientId || 'unavailable';
        });
      } catch {
        // Store may not be available yet
      }

      const reason = error?.message ?? String(error);

      this.auditActionsService.createUnauthAuditAction({
        action: AuditActionUiTypes.APP_UNCAUGHT_ERROR,
        createdBy: patientId,
        patientId,
        ...(requestId ? { requestId } : {}),
        reason,
      });
    } catch {
      // Silently fail - audit write should never cause further errors
    }

    captureException(error);
    console.error(error);
  }
}
